<template>
  <div>
    <div class="flex flex-row gap-3">
      <folder-grid-item
        class="w-52 h-52"
        :item="item"
        :rank="item.rank"
        :draggable="false"
        :is-edit-form="true"
      />
      <div class="flex flex-col flex-grow gap-5">
        <div class="form-group flex flex-col flex-grow">
          <label class="block text-sm font-medium">
            {{ $t('Text') }}
          </label>
          <div class="mt-1 rounded-md shadow-sm flex-grow">
            <textarea 
              type="text" 
              v-model="$formValues['frm-editForm-editForm-icon_text']" 
              class="form-control h-full"
              :placeholder="$formValues['frm-editForm-editForm-name']"
            />
          </div>
        </div>
        <div class="ColorPickers__Wrapper flex flex-row gap-3 mt-auto w-full">
          <div class="form-group w-full">
            <label class="block text-sm font-medium">
              {{ $t('Background color') }}
            </label>
            <aw-color-picker 
              v-model="bgColor" 
              class="form-control nomultiple p-0 outline-none ring-0 block !w-44 text-sm placeholder-gray-600"
            />
          </div>
          <div class="form-group w-full">
            <label class="block text-sm font-medium">
              {{ $t('Text color') }}
            </label>
            <aw-color-picker 
              v-model="textColor" 
              class="form-control nomultiple p-0 outline-none ring-0 block !w-44 text-sm placeholder-gray-600"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'

export default {
  computed: {
    ...mapStores(useBcSelectedStore),
    bgColor: {
      get() {
        return this.$formValues['frm-editForm-editForm-icon_bg_color']
      },
      set(val) {
        console.log('set bgColor', val)
        this.$formValues['frm-editForm-editForm-icon_bg_color'] = val
      }
    },
    textColor: {
      get() {
        return this.$formValues['frm-editForm-editForm-icon_text_color']
      },
      set(val) {
        console.log('set textColor', val)
        this.$formValues['frm-editForm-editForm-icon_text_color'] = val
      }
    },
    item() {
      return {
        ...this.bcSelectedStore.list[0],
        image__file: !this.bgColor && this.$controls['frm-editForm-editForm-image__file_id'].file
          ? this.$controls['frm-editForm-editForm-image__file_id'].file
          : null,
        icon_bg_color: this.bgColor,
        icon_text: this.$formValues['frm-editForm-editForm-icon_text'],
        icon_text_color: this.textColor,
        name: this.$formValues['frm-editForm-editForm-name']
      }
    }
  },
}
</script>

<style lang="scss">
.ColorPickers__Wrapper {
  > div > div,
  > div > div > div:first-child,
  > div > div > div:first-child input {
    width: 100% !important;
  }
}
</style>
